import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './admin-companies.loaders';
import { adminCompaniesKeys } from './admin-companies.queries';

export const useAdminUpdateCompanySettings = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateCompanySettings, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminCompaniesKeys.all);
    },
  });
};
